module.exports = __webpack_public_path__ + "img/02.8f84cc72.png";